import { getCachedItem, cacheItem } from '../localCache';

// Kept in the browser only, per signed in user, so admins sharing a browser
// don't see each other's history.
const CACHE_KEY = 'recentlyUsed';
const MAX_ITEMS_PER_TYPE = 5;

export const TYPES = ['book', 'assignment', 'screeningassignment'];

function emptyItems() {
	return TYPES.reduce((items, type) => ({ ...items, [type]: [] }), {});
}

const state = () => ({
	itemsByUser: getCachedItem(CACHE_KEY) ?? {},
});

const getters = {
	items: (state, getters, rootState, rootGetters) => {
		const userId = rootGetters['user/user']?.id;
		return { ...emptyItems(), ...(state.itemsByUser[userId] ?? {}) };
	},
	hasItems: (state, getters) => TYPES.some(type => getters.items[type].length),
};

const actions = {
	// Call when a book, assignment or screening is opened for editing.
	track({ commit, rootGetters }, { type, item }) {
		const userId = rootGetters['user/user']?.id;
		if (!userId || !TYPES.includes(type) || !item) {
			return;
		}
		commit('track', {
			userId,
			type,
			entry: {
				id: item.id,
				title: item.title,
				course: item.course?.title ?? null,
				usedAt: new Date().toISOString(),
			},
		});
	},
	forget({ commit, rootGetters }, { type, id }) {
		const userId = rootGetters['user/user']?.id;
		if (!userId) {
			return;
		}
		commit('forget', { userId, type, id });
	},
};

const mutations = {
	track(state, { userId, type, entry }) {
		const userItems = { ...emptyItems(), ...(state.itemsByUser[userId] ?? {}) };
		userItems[type] = [entry, ...userItems[type].filter(item => item.id !== entry.id)].slice(
			0,
			MAX_ITEMS_PER_TYPE,
		);
		state.itemsByUser = { ...state.itemsByUser, [userId]: userItems };
		cacheItem(CACHE_KEY, state.itemsByUser);
	},
	forget(state, { userId, type, id }) {
		const userItems = state.itemsByUser[userId];
		if (!userItems?.[type]) {
			return;
		}
		state.itemsByUser = {
			...state.itemsByUser,
			[userId]: { ...userItems, [type]: userItems[type].filter(item => item.id !== id) },
		};
		cacheItem(CACHE_KEY, state.itemsByUser);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
